import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Header, Footer } from "@/components/Chrome";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Account, { Login, AuthCallback } from "@/pages/Account";
import Admin from "@/pages/Admin";
import { OrderConfirmed, PaymentSuccess, PaymentCancel, TrackOrder, PaypalReturn } from "@/pages/Orders";
import Certificate from "@/pages/Certificate";
import { Journal, JournalPost, About, Craftsmanship, Contact } from "@/pages/Content";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function Shell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Catalog />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-confirmed/:orderId" element={<OrderConfirmed />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/payment/paypal/return" element={<PaypalReturn />} />
          <Route path="/certificate/:orderId" element={<Certificate />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<JournalPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/craftsmanship" element={<Craftsmanship />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Shell />
          <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "Outfit, sans-serif" } }} />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
